<template>
  <div style="min-height: 92vh">
    <v-form>
      <v-row>
        <v-col col="12" md="6">
          <label>Fecha inicial</label>
          <Datepicker
            :input-class="'v-input__control theme--light v-text-field dateinputClass '"
            @selected="selectDate"
            :value="input_date.format('MM/DD/YYYY')"
          ></Datepicker>
          <v-switch
            v-model="searchByCreationDate"
            label="Buscar por fecha creación"
          ></v-switch>
        </v-col>
        <v-col col="12" md="6">
          <label>Fecha final</label>
          <Datepicker
            :input-class="'v-input__control theme--light v-text-field dateinputClass'"
            @selected="selectDateFinal"
            :disabled-dates="disableDates"
            :value="input_date_final.format('MM/DD/YYYY')"
          ></Datepicker>
        </v-col>
        <v-col col="12" md="4" class="mt-n6">
          <v-autocomplete
            label="Membresia"
            v-model="selectClient"
            item-value="value"
            item-text="text"
            :items="Membresias"
          ></v-autocomplete>
        </v-col>
        <v-col col="12" md="4" class="mt-n6">
          <v-select
            prepend-icon="mdi-format-list-bulleted"
            v-model="concepto"
            :items="comp_conceptos"
            item-text="dscr"
            item-value="dscr"
            label="Conceptos"
          ></v-select>
        </v-col>
        <v-col col="12" md="4" class="mt-n6">
          <v-select
            v-if="false"
            v-model="mpago"
            :items="metodosPago"
            item-value="id"
            item-text="Nombre"
            label="Metodos de pago"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="pa-1">
        <v-btn
          small
          @click="
            selectClient = '';
            concepto = null;
            mpago = null;
          "
          dark
          class="mx-1"
          color="blue"
        >
          Limpiar filtro
        </v-btn>
        <v-btn @click="getMovimientos()" small color="success"> Buscar </v-btn>
      </v-row>
    </v-form>
    <v-container>
      <v-row>
        <v-col md="8"> Resultados: </v-col>
        <v-col md="4" class="text-right">

          <v-btn color="green" dark @click="exportExcel"
            ><v-icon>mdi-file-excel-box</v-icon> Exportar a Excel</v-btn
          >
          <!-- <download-excel
            type="xls"
            name="Movimientos Membresias"
            :data="excelData"
          >
          </download-excel> -->
        </v-col>
      </v-row>
      <div v-if="loadingData == true">
        <div>Cargando</div>
      </div>
      <v-simple-table>
        <thead>
          <tr>
            <th>Miembro</th>
            <th>Fecha</th>
            <th>Fecha Creación</th>
            <th>Monto Pago Membresia</th>
            <th>Descripcion</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="ventas_comp.length == 0">
            <td colspan="7">No se encontraron datos</td>
          </tr>
          <template v-for="(res, index) in ventas_comp">
            <tr :key="index">
              <td>{{ getMembresiaData(res.Membresia).text }}</td>
              <td>{{ res.Fecha }}</td>
              <td>{{ new Date(res.FechaCreacion).toISOString() }}</td>
              <td>
                {{ formatNumber(res.Cantidad.C) }}
                {{ res.Cantidad.M }}
              </td>
              <td>{{ res.Concepto }}</td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </v-container>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>

<script>
import "../../assets/css/sideBar.css";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import { mapGetters } from "vuex";
import MembresiaPlan from "../../clases/Membresias/MembresiaPlan.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import Cliente from "../../clases/Cliente";
import Currencies from "../../clases/Currencies.js";
import resumenVenta from "../MainComponents/resumenVenta.vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "ReporteMovimientos",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      concepto: null,
      mpago: null,
      searchByCreationDate: false,
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      planesMembresia: [],
      Membresias: [],
      reservations: [],
      metodosPago: [],
      conceptos: [],
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    comp_conceptos() {
      let array = [];
      let conc = Object.entries(this.conceptos);
      conc.forEach((concepto) => {
        array.push(concepto[1]);
      });
      return array;
    },
    ventas_comp() {
      let data = this.data_ventas;
      if (this.concepto) {
        let arr = data.filter((elem) => {
          return elem.Concepto.includes(this.concepto);
        });
        return arr;
      }
      return this.data_ventas;
    },
    excelData() {
      let data = [];
      this.data_ventas.forEach((item) => {
        let creacion = new Date(item.FechaCreacion);
        let membresia = this.getMembresiaData(item.Membresia);
        data.push({
          CodigoMembresia: membresia.Code
            ? membresia.Code.Pre + "-" + membresia.Code.Pos
            : "",
          Plan: membresia.PlanName,
          Miembro: membresia.ClienteName,
          Descripcion: item.Concepto,
          Periodo: item.Periodo,
          MontoPago: this.formatNumber(item.Cantidad.C),
          Moneda: item.Cantidad.M,
          Fecha: item.Fecha,
          FechaCreacion:
            creacion.getDate() +
            "/" +
            creacion.getMonth() +
            "/" +
            creacion.getFullYear() +
            " " +
            creacion.getHours() +
            ":" +
            creacion.getMinutes(),
        });
      });
      if (this.concepto) {
        let arr = data.filter((elem) => {
          return elem.Descripcion.includes(this.concepto);
        });
        return arr;
      }
      return data;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
      });
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.Id;
        cli.text = cli.getNombreCompleto();
      });
      return clientes;
    },
  },
  methods: {
    exportExcel() {
     GenericExcelExporter.generateExcelBuffer(this.excelData)
       .then(buffer => {
         const blob = new Blob([buffer], {
           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = "Reporte movimientos.xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       })
       .catch(error => console.error("Error exportando:", error));
   },
    async getConceptos() {
      const database = this.$store.getters.getFirebaseApp.database;
      const ref = database.ref("MBS/Conceptos");
      const snapshot = await database.get(ref);
      if (!snapshot.exists()) {
        return false;
      }
      this.conceptos = snapshot.val();
    },
    getPlanData(id) {
      let plan = {};
      let cliente = this.$pgsHelper.getById(this.comp_clients, "Id", id);
      let idPlan = cliente.ExtraData?.Membresia?.Plan;
      plan = this.$pgsHelper.getById(this.planesMembresia, "Id", idPlan);
      return plan;
    },
    getMembresiaData(id) {
      let membresia = {};
      let idMembresia = id;
      membresia = this.$pgsHelper.getById(this.Membresias, "Id", idMembresia);
      // membresia.Codigo = membresia?.Code
      //   ? membresia.Code.Pre + "-" + membresia.Code.Pos
      //   : "";
      return membresia;
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getMovimientos() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.getFirebaseApp.firestore;

      let filter = [
        firestore.where("Tenant", "==", this.getFirebaseApp.tenant),
      ];

      if (this.searchByCreationDate) {
        filter.push(
          firestore.where("FechaCreacion", ">=", this.input_date.valueOf())
        );
        filter.push(
          firestore.where("FechaCreacion", "<", this.input_date_final.valueOf())
        );
        filter.push(firestore.orderBy("FechaCreacion", "desc"));
        filter.push(firestore.orderBy("Fecha", "desc"));
        filter.push(firestore.limit(1000));
      } else {
        filter.push(firestore.where("Fecha", ">=", startDate));
        filter.push(firestore.where("Fecha", "<", end));
        filter.push(firestore.orderBy("Fecha", "desc"));
        filter.push(firestore.orderBy("FechaCreacion", "desc"));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Membresia", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("MBS_Movimientos", filter);

      /*if(this.input_folio != ''){
            data = data.where("id","==",this.id);
        }

        if(this.selectClient != ''){
            data = data.where("Cliente.Id","==",this.selectClient);
        }*/

      let data_ventas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      data_ventas.forEach((ventas) => {
        ventas.membresia = this.$pgsHelper.getById(
          ventas.Catalogo,
          "Id",
          "MBS-Deposito~Membresia"
        );
      });

      this.data_ventas = data_ventas;

      this.showEstad = true;
    },
  },
  beforeCreate: function () {},
  beforeMount: async function () {
    this.getConceptos();
    this.planesMembresia = await MembresiaPlan.getMembresiasPlanList();
    this.Membresias = await Membresia.getMembresiasList();
    this.Membresias.forEach((membresia) => {
      let clientedata = this.$pgsHelper.getById(
        this.comp_clients,
        "Id",
        membresia.Titular
      );
      let plan = this.$pgsHelper.getById(
        this.planesMembresia,
        "Id",
        membresia.Plan
      );
      membresia.PlanName = plan ? plan.Nomb : "Sin plan";
      membresia.ClienteName = clientedata ? clientedata.text : "Sin Cliente";
      membresia.text =
        membresia.Code.Pre +
        "" +
        membresia.Code.Pos +
        " - " +
        (clientedata ? clientedata.text : "Sin Cliente") +
        " - " +
        plan.Nomb;
      membresia.value = membresia.Id;
    });
    this.getMovimientos();
    this.metodosPago = Currencies.getPagos();
    this.$emit("useNav", true);
  },
};
</script>
